import { useState, useEffect, useCallback } from 'react';
import authorizedFetch, { authorizedPost } from '../api-authorization/AuthorizedFetch';
import { safeParseResponse } from '../../utils';

let _pulseIdentifier = null;

const getPulseIdentifier = () => {
    if(_pulseIdentifier == null) {
        _pulseIdentifier = window.localStorage.getItem("pulse-identifier");

        if(_pulseIdentifier == null){
            _pulseIdentifier = crypto.randomUUID();
            window.localStorage.setItem("pulse-identifier", _pulseIdentifier);
        }
    }

    return _pulseIdentifier;
}

const usePulse = (engagementPulseId) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [engagementLevel, setEngagementLevel] = useState(null);

    const fetchData = useCallback(async () => {
        const response = await authorizedFetch(`api/engagement-pulses/${engagementPulseId}`);

        if(response.status === 200)
        {
            const pulse = await safeParseResponse(response);
            setData({
                total: pulse.engagementPulse.responses.length,
                disengaged: pulse.engagementPulse.responses.filter(r => r.level === 0).length,
                engaged: pulse.engagementPulse.responses.filter(r => r.level === 1).length,
                reactive: pulse.engagementPulse.responses.filter(r => r.level === 2).length
            });
        }

        setLoading(false);
    }, [engagementPulseId, setData, setLoading]);

    const respond = async (level) => {
        var d = { ...data };
        if(engagementLevel == null)
            d.total++;

        if(engagementLevel === 0)
            d.disengaged--;
        
        if(engagementLevel === 1)
            d.engaged--;

        if(engagementLevel === 2)
            d.reactive--;

        setEngagementLevel(level);
        
        if(level === 0)
            d.disengaged++;
        
        if(level === 1)
            d.engaged++;

        if(level === 2)
            d.reactive++;

        setData(d);

        const identifier = getPulseIdentifier();
        const response = await authorizedPost(`api/engagement-pulses/${engagementPulseId}`, { identifier, level });
    
        return response.status === 200;
    }

    useEffect(() => {
        fetchData();
        const reloadInterval = setInterval(fetchData, 2000);
        return () => {
            clearInterval(reloadInterval);
        }
    }, [fetchData]);

    return {
        data,
        loading,
        engagementLevel,
        setEngagementLevel: respond
    };
}

export default usePulse;